import "./Style.scss";
import Details from "./Details";
import JobListing from "./JobListing";

export { JobListing, Details };
